export default __webpack_public_path__ + "static/media/serviceBlock5.c65bf2fb.jpeg";